<template>
    <div class="bg-default flex-x-center">
        <el-form ref="form" :model="form" :rules="rules" size="small" label-position="left" label-width="84px" class="mt-24" style="width: 500px">
            <idc-form-item :form="form" :config="formConfig" :rules="rules" col="24" clearable>
                <template #password>
                    <d-dialog :outClose="addOutClose" title="重置密码" width="480px" class="mr-12">
                        <el-button size="small">
                            修改密码
                        </el-button>
                        <template #contain>
                            <reset-password-dialog :row="{}" @cancel="addOutClose = !addOutClose" />
                        </template>
                    </d-dialog>
                </template>
                <template>
                    <div class="flex-center">
                        <el-avatar :size="60" :src="src" :key="src" class="mr-24" />
                        <el-upload
                            :action="$service.personCenter.uploadPicture"
                            :headers="uploadHeader"
                            :show-file-list="false"
                            :before-upload="beforeAvatarUpload"
                            :on-success="uploadSuccess"
                            class="upload-demo"
                            method="post"
                            name="portrait"
                            list-type="picture"
                        >
                            <el-button size="small" type="primary">
                                点击上传
                            </el-button>
                            <div slot="tip" class="el-upload__tip">
                                只能上传jpg/png文件
                            </div>
                        </el-upload>
                    </div>
                </template>
                <el-button @click="submit" type="primary" style="margin-left: 84px">
                    修改
                </el-button>
            </idc-form-item>
        </el-form>
    </div>
</template>

<script>
import resetPasswordDialog from './resetPasswordDialog';
export default {
    components: { resetPasswordDialog },
    data() {
        return {
            form: {},
            src: '',
            addOutClose: false,
            formConfig: [
                { itemType: 'input', prop: 'name', label: '', hasSlot: true },
                { itemType: 'input', prop: 'userName', label: '账号：', disabled: true },
                { itemType: 'input', prop: 'realName', label: '姓名：' },
                { itemType: 'input', prop: 'email', label: '邮箱：', require: true },
                { itemType: 'input', prop: 'phone', label: '手机号：', require: true },
                { itemType: 'input', prop: 'idCards', label: '身份证号：' }
                // { itemType: 'input', prop: 'password', label: '密码：', hasSlot: true }
            ],
            fileType: {
                portrait: 'png'
            },
            rules: {
                email: [{ pattern: this.$Valid.Email, message: '邮箱格式错误', trigger: 'blur' }],
                idCards: [{ pattern: this.$Valid.IDCard, message: '身份证号格式错误', trigger: 'blur' }],
                phone: [{ pattern: this.$Valid.MobilePhoneNumber, message: '手机号格式错误', trigger: 'blur' }]
            },
            uploadHeader: {
                token: JSON.parse(sessionStorage.getItem('token')) || ''
            }
        };
    },
    created() {
        this.getPic();
        this.getUserInfo();
        Object.defineProperty(Image.prototype, 'authsrc', {
            writable: true,
            enumerable: true,
            configurable: true
        });
    },
    methods: {
        getPic() {
            this.$http.get(this.$service.personCenter.getImage, { responseType: 'blob' }).then(res => {
                if (res) {
                    this.src = URL.createObjectURL(res);
                } else {
                    this.src = '';
                }
            });
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                if (!this.form.realName) {
                    this.$message({
                        type: 'warning',
                        message: '姓名不能为空'
                    });
                    return;
                }
                // if (!this.form.phone) {
                //     this.$message({
                //         type: 'warning',
                //         message: '手机号不能为空'
                //     });
                //     return;
                // }
                let params = {
                    email: this.form.email,
                    phone: this.form.phone,
                    userId: this.form.userId,
                    idCards: this.form.idCards,
                    realName: this.form.realName
                };

                this.$http.post(this.$service.personCenter.setUserInfo, params).then(res => {
                    if (res && res.message.indexOf('成功')) {
                        this.getPic();
                        this.getUserInfo();
                        this.$message.success('修改成功');
                    } else {
                        this.message.error(res.message || '修改失败');
                    }
                });
            });
        },

        beforeAvatarUpload(file) {
            if (file.size > 1024 * 1024) {
                this.$message.error('上传文件过大,不允许超过1M!');
                return false;
            }
            if (file.type != 'image/jpg' && file.type != 'image/png' && file.type != 'image/jpeg') {
                this.$message.error('上传头像图片格式不正确!');
                return false;
            }

            return true;
        },
        uploadSuccess() {
            this.getPic();
            this.$store.commit('changeUserInfo', true);
        },
        getUserInfo() {
            this.$http.get(this.$service.personCenter.getUserInfo).then(res => {
                if (res.message === '查询成功' || res.message === 'ok') {
                    this.form = res.data;
                } else {
                    this.$message.error('查询失败!');
                }
            });
        }
    }
};
</script>
